import { useSelector } from 'react-redux';

import { uploaderIsUploadingSelector } from '@air/redux-uploader';

import { useCalculateUploadSpeed } from './useCalculateUploadSpeed';
import { useUploadCancelAlertOnUnload } from './useUploadCancelAlertOnUnload';
import { useUploadsOfflineListener } from './useUploadsOfflineListener';
import { useWakelock } from './useWakelock';

export const useUploadsTrackingSession = () => {
  useUploadCancelAlertOnUnload();
  useCalculateUploadSpeed();
  const isUploading = useSelector(uploaderIsUploadingSelector);
  useWakelock(isUploading);
  const { isOnline } = useUploadsOfflineListener();

  return { isOnline };
};
